module.exports = __webpack_public_path__ + "img/triangle.667176b8.svg";